import { render, staticRenderFns } from "./SafetyObservationNewForm.vue?vue&type=template&id=415e79f0&scoped=true"
import script from "./SafetyObservationNewForm.vue?vue&type=script&lang=js"
export * from "./SafetyObservationNewForm.vue?vue&type=script&lang=js"
import style0 from "./SafetyObservationNewForm.vue?vue&type=style&index=0&id=415e79f0&prod&lang=css"
import style1 from "./SafetyObservationNewForm.vue?vue&type=style&index=1&id=415e79f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415e79f0",
  null
  
)

export default component.exports